import { PLAN_COMPARE } from "../../util/accountSetupCopy";

export const PlanCompare = ({ freeFeeLabel, paidFeeLabel }) => (
  <section className="setup-guide" data-testid="plan-compare">
    <p className="setup-guide-kicker">{PLAN_COMPARE.kicker}</p>
    <h2 className="setup-guide-title">{PLAN_COMPARE.title}</h2>
    <p className="setup-guide-lead">{PLAN_COMPARE.lead}</p>
    <div className="setup-compare">
      <article className="setup-compare-card">
        <p className="setup-compare-name">{PLAN_COMPARE.free.name}</p>
        <p className="setup-compare-price">{PLAN_COMPARE.free.price}</p>
        <ul>
          <li>{PLAN_COMPARE.free.points[0]}</li>
          <li>{freeFeeLabel || PLAN_COMPARE.free.points[1]}</li>
          <li>{PLAN_COMPARE.free.points[2]}</li>
        </ul>
      </article>
      <article className="setup-compare-card is-paid">
        <p className="setup-compare-name">{PLAN_COMPARE.paid.name}</p>
        <p className="setup-compare-price">{PLAN_COMPARE.paid.price}</p>
        <ul>
          <li>{PLAN_COMPARE.paid.points[0]}</li>
          <li>{paidFeeLabel || PLAN_COMPARE.paid.points[1]}</li>
          <li>{PLAN_COMPARE.paid.points[2]}</li>
        </ul>
      </article>
    </div>
  </section>
);

export const VendorSetupGuide = ({ copy }) => (
  <section className="setup-guide" data-testid="vendor-setup-guide">
    <p className="setup-guide-kicker">{copy.kicker}</p>
    <h2 className="setup-guide-title">{copy.title}</h2>
    <div className="setup-guide-grid">
      {copy.items.map((item) => (
        <article key={item.label} className="setup-guide-item">
          <p className="setup-guide-label">{item.label}</p>
          <p className="setup-guide-body">{item.body}</p>
        </article>
      ))}
    </div>
  </section>
);
